import { Component, Input, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { gridPageRequest } from '../../../model/common/common.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import _ from 'lodash';
import { MessageService } from 'primeng/api';
import { SalesService } from '../../../services/sales.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-linked-files-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule, AutoCompleteModule],
  templateUrl: './linked-files.lookup.component.html',
  styleUrl: './linked-files.lookup.component.scss',
  providers: [MessageService]
})
export class LinkedFilesLookupComponent implements OnInit {

  fileTypes: any[] | undefined;
  isEdit: any;
  loader: boolean = false;
  fileContent: string = '';
  fileType: 'pdf' | 'image' | 'word' | 'wordpad' | 'txt' | 'excel' = 'pdf';
  selectedFile: File | null = null;

  @Input() productBoMId: any;
  filteredProducts: any[] = [];
  products: [] = [];
  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 100,
    id: 0
  };

  filterProductList: any[] = [];
  saveData: any;
  submitted: boolean = false;
  orderNo: any;
  linkedId: any;

  documentTypeOptions = [
    { label: 'PDF', value: 'pdf' },
    { label: 'Image', value: 'image' },
    { label: 'Word Document', value: 'word' },
    { label: 'WordPad', value: 'wordpad' },
    { label: 'Text File', value: 'txt' },
    { label: 'Excel', value: 'excel' }
  ];

  constructor(
    public ref: DynamicDialogRef,
    private messageService: MessageService,
    private salesService: SalesService,
    private config: DynamicDialogConfig
  ) { }

  ngOnInit(): void {
    const todayDate = new Date();
    this.linkedFiledForm.controls['createdDate'].setValue(todayDate);
    this.linkedFiledForm.controls['createdBy'].setValue(sessionStorage.getItem('username'));
    this.linkedFiledForm.controls['linkedBy'].setValue(sessionStorage.getItem('username'));
    const orderNo = this.config?.data?.orderId;
    this.orderNo = orderNo;
    if (this.orderNo) {
      this.linkedFiledForm.patchValue({ orderId: this.orderNo });
    }
    this.linkedId = orderNo;
    this.reOpen();
    this.linkedFiledForm.controls.date.setValue(new Date());
  }

  linkedFiledForm = new FormGroup({
    orderId: new FormControl(),
    type: new FormControl('', Validators.required),
    description: new FormControl(),
    date: new FormControl<Date | null>(null, Validators.required),
    linkedBy: new FormControl(''),
    FilePath: new FormControl(),
    sendMail:  new FormControl(false),
    isActive: new FormControl(true),
    createdDate: new FormControl(),
    createdBy: new FormControl(),
    updatedBy: new FormControl(),
    updatedDate: new FormControl(),
  });

  get formControls() {
    return this.linkedFiledForm.controls;
  }

  onFileChange(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    const file = fileInput.files?.[0];

    if (!file) {
      this.messageService.add({ severity: 'error', summary: 'No File Selected', detail: 'Please select a file to upload.' });
      return;
    }

    const maxFileSize = 10 * 1024 * 1024;
    if (file.size > maxFileSize) {
      this.messageService.add({ severity: 'warn', summary: 'File Too Large', detail: 'File size exceeds 10 MB.' });
      return;
    }

    const selectedType = this.linkedFiledForm.get('type')?.value as 'pdf' | 'image' | 'word' | 'wordpad' | 'txt' | 'excel';
    const fileExtension = file.name.split('.').pop()?.toLowerCase();

    const valid = this.validateFileType(fileExtension, selectedType);
    if (!valid) {
      return;
    }

    this.selectedFile = file;
  }

  validateFileType(extension: string | undefined, selectedType: string): boolean {
    const map: any = {
      pdf: ['pdf'],
      word: ['doc', 'docx'],
      wordpad: ['rtf'],
      txt: ['txt'],
      excel: ['xls', 'xlsx'],
      image: ['jpg', 'jpeg', 'png', 'gif']
    };

    if (!extension || !map[selectedType]?.includes(extension)) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid File Type',
        detail: `Please upload a valid ${selectedType.toUpperCase()} file.`
      });
      return false;
    }

    return true;
  }

  saveLinkedFiles(data: any, isEditMode: boolean) {
    // Check if the document type is selected
    if (!data.type) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please first select a Document Type.'
      });
      return;
    }

    if (!this.validateForm()) return;

    if (this.selectedFile) {
      const fileExtension = this.selectedFile.name.split('.').pop()?.toLowerCase();
      const selectedType = data.type as 'pdf' | 'image' | 'word' | 'wordpad' | 'txt' | 'excel';
      const valid = this.validateFileType(fileExtension, selectedType);

      if (!valid) {
        return;
      }
    } else if (!isEditMode) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select a file to upload.'
      });
      return;
    }

    const formData = new FormData();
    formData.append('orderId', this.orderNo);
    formData.append('type', data.type);
    formData.append('description', data.description ?? '');
    formData.append('linkedBy', data.linkedBy);
    formData.append('sendMail', data.sendMail);
    formData.append('date', data.date?.toISOString());

    if (isEditMode && !this.selectedFile) {
      formData.append('filePath', this.fileContent);
    } else if (this.selectedFile) {
      formData.append('file', this.selectedFile);
    }

    if (isEditMode) {
      this.Update(formData);
    } else {
      this.createLinkedFiles(formData);
    }
}


  createLinkedFiles(formData: FormData) {
    this.loader = true;
    formData.append('createdBy', localStorage.getItem('username') || '');
    this.salesService.createLinkedFiles(formData).subscribe({
      next: (response: any) => {
        this.loader = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Linked File Created'
        });

        setTimeout(() => {
          this.ref.close({ success: true, message: 'Linked File Created' });
        }, 2000);
      },
      error: (error: any) => {
        this.loader = false;
        const errorMessage = error?.error?.message || 'A file with the same name already exists for this order.';
        this.messageService.add({
          severity: 'warn',
          summary: 'Warning',
          detail: errorMessage
        });
      }
    });
  }

  validateForm() {
    let isValid = true;
    if (this.linkedFiledForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill required fields' });
      isValid = false;
    }
    return isValid;
  }

  Update(data: any) {
    if (data) {
      data.updatedBy = localStorage.getItem('username');
      this.loader = true;
      data.linkedId = this.linkedId;
      this.salesService.updateLinkedFile(data).subscribe({
        next: (data: any) => {
          this.loader = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Linked File Updated Successfully.'
          });

          setTimeout(() => {
            this.ref.close({ success: true });
          }, 2000);
        },
        error: error => {
          this.loader = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Update failed. Please try again.'
          });
        }
      });
    }
  }

  reOpen() {
    const linkedFileId = this.linkedId;
    this.salesService.getLinkedFileId(linkedFileId).subscribe({
      next: (data: any) => {
        if (Array.isArray(data) && data.length > 0) {
          const linkedFile = data[0];
          this.isEdit = true;
          this.linkedFiledForm.patchValue({
            orderId: linkedFile.orderId,
            type: linkedFile.type,
            FilePath: linkedFile.filePath,
            description: linkedFile.description ?? undefined,
            linkedBy: linkedFile.linkedBy,
            sendMail: linkedFile.sendMail,
            date: linkedFile.date ? new Date(linkedFile.date) : null,
          });

          this.fileContent = linkedFile.filePath;
          this.fileType = linkedFile.type;
        } else {
          console.warn('No linked file found for the given ID.');
        }
      },
      error: (error) => {
        console.error('Error fetching linked file:', error);
        this.loader = false;
      }
    });
  }

  viewDocument(filePath: any) {
    if (!filePath) {
      console.error('Invalid file path');
      return;
    }

    try {
      const decodedPath = decodeURIComponent(filePath);
      const fullUrl = decodedPath.startsWith('http')
        ? decodedPath
        : `${environment.apiBaseUrl}/${decodedPath}`;
      window.open(fullUrl, '_blank');
    } catch (e) {
      console.error('Failed to decode file path', e);
    }
  }

  cancel(data: any) {
    this.ref.close();
  }

}
